import {
  IDropdownFieldConfigurationClient,
  IDropdownFieldConfigurationServer,
  IDropdownFieldOptionsClient,
  IFormDropdownOptionServer,
} from "./interface";
import { IToggleDynamicOptions } from "../DynamicOptionsSetup/interface";
import { dynamicOptionsSetupInitialValue } from "../DynamicOptionsSetup/utils";
import { SelectionTypes } from "../FormFieldSelector/interfaces";

export const transformDropdownOptionClientToServer = (
  dropdownOptionsClient: IDropdownFieldOptionsClient[]
) => {
  const dropdownOptionsServer: IFormDropdownOptionServer[] = [];

  dropdownOptionsClient?.forEach(
    (dropdownOptionClient: IDropdownFieldOptionsClient) => {
      const { optionKey, optionValue } = dropdownOptionClient;

      const dropdownOptionServer = {
        key: optionKey,
        value: optionValue,
      } as IFormDropdownOptionServer;

      dropdownOptionsServer?.push(dropdownOptionServer);
    }
  );

  return dropdownOptionsServer;
};
export const transformDropdownOptionServerToClient = (
  dropdownOptionsServer: IFormDropdownOptionServer[]
) => {
  if (!dropdownOptionsServer) return;
  const dropdownOptionsClient: IDropdownFieldOptionsClient[] = [];

  dropdownOptionsServer?.forEach(
    (dropdownOptionServer2: IFormDropdownOptionServer) => {
      const { key, value } = dropdownOptionServer2;

      const dropdownOptionClient = {
        optionKey: key,
        optionValue: value,
      } as IDropdownFieldOptionsClient;

      dropdownOptionsClient.push(dropdownOptionClient);
    }
  );
  return dropdownOptionsClient;
};

export const transformDropdownFieldConfigClientToServer = (
  fieldConfigClient: IDropdownFieldConfigurationClient
): IDropdownFieldConfigurationServer => {
  const { options, sort, initialValue, dynamicOptionsSetup, selectedType, writeJavascript, initialValueWithAccessKey } =
    fieldConfigClient;

  const enableDynamicFetch = dynamicOptionsSetup?.enableDynamicFetch || false;
  const dynamicApiUri = dynamicOptionsSetup?.dynamicApiUri || "";
  const dataConversionFunction =
    dynamicOptionsSetup?.dataConversionFunction || "";

  const validatedSelectedType = selectedType === "" || !selectedType
    ? SelectionTypes.SINGLE_SELECTION
    : selectedType;

  const fieldConfigServer = {
    options: transformDropdownOptionClientToServer(options),
    sort: { selected: sort },
    selectedType: { selected: validatedSelectedType },
    initialValue: initialValue,
    enableDynamicFetch,
    dynamicApiUri,
    dataConversionFunction,
    writeJavascript: writeJavascript,
    initialValueWithAccessKey: initialValueWithAccessKey,
  };
  return fieldConfigServer;
};

export const transformDropdownFieldConfigServerToClient = (
  fieldConfigServer: IDropdownFieldConfigurationServer
): IDropdownFieldConfigurationClient => {
  const {
    placeHolder,
    sort,
    selectedType,
    options,
    initialValue,
    enableDynamicFetch,
    dynamicApiUri,
    dataConversionFunction,
    writeJavascript,
    initialValueWithAccessKey
  } = fieldConfigServer;

  const dynamicOptionsSetup: IToggleDynamicOptions = {
    ...dynamicOptionsSetupInitialValue,
    enableDynamicFetch,
    dynamicApiUri,
    dataConversionFunction,
  };

  const fieldConfigClient: IDropdownFieldConfigurationClient = {
    options: transformDropdownOptionServerToClient(options),
    placeholder: placeHolder,
    sort: sort?.selected,
    selectedType: selectedType?.selected,
    initialValue: initialValue,
    dynamicOptionsSetup: dynamicOptionsSetup,
    writeJavascript: writeJavascript,
    initialValueWithAccessKey: initialValueWithAccessKey,
  };
  return fieldConfigClient;
};

type areStringsEqualType = string | number | boolean | null | undefined;
export const areStringsEqual = (str1: areStringsEqualType, str2: areStringsEqualType) => {
  const normalize = (s: areStringsEqualType) => String(s ?? '').replace(/\s+/g, '').toLowerCase();
  return normalize(str1) === normalize(str2);

}